import React from "react";

const InternshipPolicy = () => {
  return (
    <div className="min-h-screen bg-white px-6 py-12 text-gray-800">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-4xl font-bold text-center mb-8 text-indigo-700">
          INTERNSHIP POLICY
        </h1>
        <h2 className="text-xl font-semibold text-center mb-10">
          TECHVERRA SOLUTIONS PRIVATE LIMITED
        </h2>

        

        {[
          {
            title: "1. Purpose",
            content:
              "This Internship Policy outlines the formal framework under which interns are engaged at TECHVERRA SOLUTIONS PRIVATE LIMITED (\"the Company\"). The purpose is to ensure a legally compliant, secure, professional, and mutually beneficial internship program that aligns with the Company’s operational, cultural, and legal standards.",
          },
          {
            title: "2. Eligibility",
            content: (
              <ul className="list-disc pl-5 space-y-1">
                <li>
                  The applicant must be actively enrolled in a full-time or part-time program at a recognized university or be a recent graduate (within 12 months).
                </li>
                <li>Applicants must be at least 18 years of age at the time of joining.</li>
                <li>
                  Courses in engineering, computer science, business, cybersecurity, and related fields will be prioritized.
                </li>
                <li>Interns must not have any current or previous professional conflicts with the Company.</li>
              </ul>
            ),
          },
          {
            title: "3. Selection Process",
            content: (
              <ul className="list-disc pl-5 space-y-1">
                <li>Screening process: shortlisting, interviews, skill assessments, and HR clearance.</li>
                <li>Required documents: Resume, cover letter, transcripts, ID proof, and consent letter (if applicable).</li>
                <li>Offer Letter issued to selected candidates with scope, terms, and stipend.</li>
                <li>Background verification may be conducted.</li>
              </ul>
            ),
          },
          {
            title: "4. Internship Duration",
            content: (
              <ul className="list-disc pl-5 space-y-1">
                <li>Short (1–2 months), Medium (3–6 months), or Long (up to 12 months) durations.</li>
                <li>Details like schedule and holidays will be in the Offer Letter.</li>
                <li>Part-time or full-time options depending on department needs.</li>
              </ul>
            ),
          },
          {
            title: "5. Roles and Responsibilities",
            content: (
              <ul className="list-disc pl-5 space-y-1">
                <li>Adhere to deadlines and instructions from supervisors.</li>
                <li>Participate in required training, reviews, and documentation.</li>
                <li>Maintain professionalism and ethical conduct.</li>
                <li>Unauthorized actions may result in warnings or termination.</li>
              </ul>
            ),
          },
          {
            title: "6. Stipend and Benefits",
            content: (
              <ul className="list-disc pl-5 space-y-1">
                <li>May be paid or unpaid (defined in the Offer Letter).</li>
                <li>Stipend (if applicable) will be credited monthly/bi-monthly.</li>
                <li>No entitlement to regular company benefits or employment assurance.</li>
              </ul>
            ),
          },
          {
            title: "7. Conduct and Discipline",
            content: (
              <ul className="list-disc pl-5 space-y-1">
                <li>Follow all Company rules and ethics.</li>
                <li>Maintain punctuality, appropriate dress, and avoid misconduct.</li>
                <li>Disciplinary action may include termination or blacklisting.</li>
                <li>Interns shall abide by the Company’s Code of Conduct and the principles of good faith and fidelity.</li>
                <li>Harassment, discrimination, or any misconduct will be dealt with as per the Sexual Harassment of Women at Workplace (Prevention, Prohibition and Redressal) Act, 2013 (if applicable) and internal disciplinary rules.</li>
                <li>Punctuality, decorum, and compliance with internal rules are mandatory.</li>
              </ul>
            ),
          },
          {
            title: "8. Confidentiality, Data Handling, and IP Rights",
            content: (
              <ul className="list-disc pl-5 space-y-1">
                <li>Sign NDA before beginning work.</li>
                <li>Maintain strict data confidentiality.</li>
                <li>All work created during internship is Company IP.</li>
                <li>Legal action will be taken for violations.</li>
                <li>Breach of these obligations may invite civil and criminal action.</li>
              </ul>
            ),
          },
          {
            title: "9. Attendance, Remote Work, and Leave",
            content: (
              <ul className="list-disc pl-5 space-y-1">
                <li>Daily attendance required on assigned platform.</li>
                <li>Remote work allowed with approval; must follow schedule and meeting availability.</li>
                <li>Advance notice for absences is required.</li>
                <li>Leaves over 3 days need justification and approval.</li>
              </ul>
            ),
          },
          {
            title: "10. Certification and Evaluation",
            content: (
              <ul className="list-disc pl-5 space-y-1">
                <li>Evaluated on performance, attendance, and feedback.</li>
                <li>Certificate issued only if full term is served and no issues arise.</li>
                <li>No certificate for underperformance or violations.</li>
              </ul>
            ),
          },
          {
            title: "11. Termination",
            content: (
              <ul className="list-disc pl-5 space-y-1">
                <li>Company may terminate for violations or misconduct.</li>
                <li>Interns may resign with written notice ([Insert Duration]).</li>
                <li>Return all assets before exit.</li>
              </ul>
            ),
          },
          {
            title: "12. Liability and Disclaimer",
            content: (
              <ul className="list-disc pl-5 space-y-1">
                <li>Company not liable for intern injuries or losses.</li>
                <li>Interns must ensure own safety and proper conduct.</li>
              </ul>
            ),
          },
          {
            title: "13. Final Provisions",
            content: (
              <ul className="list-disc pl-5 space-y-1">
                
                <li>The Company reserves the right to amend or withdraw this Policy at its sole discretion, subject to companies Companies Constitution (rule book) and applicable laws.</li>
                <li>Clarifications regarding interpretation shall rest with the HR Department or Internship Coordinator.</li>
              </ul>
            ),
          },
        ].map(({ title, content }, index) => (
          <div key={index} className="mb-8">
            <h3 className="font-bold text-lg mb-2 text-indigo-600">{title}</h3>
            <div className="text-base">{content}</div>
          </div>
        ))}

        
      </div>
    </div>
  );
};

export default InternshipPolicy;
